"use client";
import StatusPDF from "@/app/[locale]/(user-page)/report/[slug]/components/StatusPDF";
import image from "@/constants/image";
import { APP_ROUTES } from "@/constants/routes";
import { useSubscription } from "@/helper/useSubscription";
import { cn } from "@/lib/utils";
import { Report } from "@/models/report";
import { OPTIONS_SUBSCRIPTION } from "@/models/subscription";
import { User } from "@/models/user";
import { MODE_REPORT } from "@/utils/AppConfig";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Box, Button } from "@mui/material";
import { motion } from "framer-motion";
import { FlameIcon } from "lucide-react";
import { useTranslations } from "next-intl";
import Image from "next/image";
import Link from "next/link";
import React, { ReactNode } from "react";

interface btnProps {
  isLoggedIn?: boolean;
  user?: User;
  dataDetail: Report | undefined;
  handleOpen: () => void;
  setOpenPopupDownload: (value: React.SetStateAction<boolean>) => void;
  mode?: string;
  locale?: string;
}

interface BtnRedirectProps {
  id: string;
  href: string;
  label: string;
  icon: ReactNode;
}

const ButtonGetReport = ({
  user,
  isLoggedIn,
  dataDetail,
  handleOpen,
  setOpenPopupDownload,
  mode,
  locale,
}: btnProps) => {
  const t = useTranslations("messages");
  // const router = useRouter();
  const { hasPermission } = useSubscription(user?.license);
  const RENDER_BUTTON_REDIRECT: BtnRedirectProps[] = [
    {
      id: MODE_REPORT.POWERBI,
      href: APP_ROUTES(locale as any).HOME.DETAIL.MODE.POWERBI.to(
        dataDetail?.slug || ""
      ),
      label: t("report_detail_view_interactive_dashboard"),
      icon: <Image src={image.icDouble} alt="iconPDF" width={24} height={24} />,
    },
    {
      id: MODE_REPORT.PDF,
      href: APP_ROUTES(locale as any).HOME.DETAIL.MODE.PDF.to(
        dataDetail?.slug || ""
      ),
      label: t("report_detail_go_to_report"),
      icon: <Image src={image.iconPDF} alt="iconPDF" width={24} height={24} />,
    },
    {
      id: MODE_REPORT.EMBED,
      href: APP_ROUTES(locale as any).HOME.DETAIL.MODE.EMBED.to(
        dataDetail?.slug || ""
      ),
      label: t("report_detail_view_embedded_report"),
      icon: <FlameIcon className="w-6 h-6 text-cimigoGreen" />,
    },
  ];

  return (
    <React.Fragment>
      {!isLoggedIn ? (
        <StatusPDF  dataDetailType={2} mode={mode} handleOpen={handleOpen} />
      ) : dataDetail?.isPaymentEd ? (
        <motion.div>
          <StatusPDF
            dataDetailType={4}
            handleOpen={() => setOpenPopupDownload(true)}
          />
        </motion.div>
      ) : hasPermission(OPTIONS_SUBSCRIPTION.PREMIUM) ? (
        <motion.div>
          <StatusPDF mode={mode} dataDetailType={-1} handleOpen={handleOpen} />
        </motion.div>
      ) : (
        <motion.div>
          <StatusPDF
            mode={mode}
            dataDetailType={
              dataDetail?.type === 3 || dataDetail?.type === 2 ? 2 : 1
            }
            handleOpen={handleOpen}
          />
        </motion.div>
      )}
      {RENDER_BUTTON_REDIRECT.filter((item) => item.id !== mode).map((item) => (
        <div
          key={item?.id}
          className={cn("", {
            "!hidden":
              (item.id === MODE_REPORT.POWERBI &&
                !dataDetail?.haveInteractive) ||
              (item.id === MODE_REPORT.PDF && !dataDetail?.havePDF) ||
              (item.id === MODE_REPORT.EMBED && !dataDetail?.haveEmbed),
          })}
        >
          <Button
            LinkComponent={Link}
            href={item.href}
            variant="text"
            className="!bg-ciBlue_light_4 !px-6 !py-4 flex !items-center !justify-between cursor-pointer w-full report-detail-view-interactive-dashboard-button"
            // onClick={() => router.push(item.href)}
          >
            <Box className="flex gap-2">
              {item.icon}
              <span
                className="font-medium text-base/6 text-ciBlue_dark_1 normal-case"
                translation-key="report_detail_view_interactive_dashboard"
              >
                {item.label}
              </span>
            </Box>
            <Box className="flex items-center">
              <ArrowForwardIcon className="text-ciBlue_dark_1" />
            </Box>
          </Button>
        </div>
      ))}
      {/* {dataDetail?.haveInteractive ? (
        <div>
          <Button
            variant="text"
            className="!bg-ciBlue_light_4 !px-6 !py-4 flex !items-center !justify-between cursor-pointer w-full report-detail-view-interactive-dashboard-button"
            onClick={handleRedirectInteractiveDashboard}
          >
            <Box className="flex gap-2">
              <IconDouple className="w-auto h-auto" />
              <span
                className="font-medium text-base/6 text-ciBlue_dark_1 normal-case"
                translation-key="report_detail_view_interactive_dashboard"
              >
                {t("report_detail_view_interactive_dashboard")}
              </span>
            </Box>
            <Box className="flex items-center">
              <ArrowForwardIcon className="text-ciBlue_dark_1" />
            </Box>
          </Button>
        </div>
      ) : null} */}
    </React.Fragment>
  );
};

export default ButtonGetReport;
